import { getLoggedInUser } from '@/lib/auth/auth-server-func'
import { authClient } from '@/lib/auth/client'
import {
  createFileRoute,
  Navigate,
  Outlet,
  redirect,
} from '@tanstack/react-router'

export const Route = createFileRoute('/_unauthRedirect')({
  component: RouteComponent,
  beforeLoad: async () => {
    const session = await getLoggedInUser()
    if (session.isLoggedIn) {
      throw redirect({ to: '/' })
    }
    return { auth: session }
  },
})

function RouteComponent() {
  const { data: session, isPending } = authClient.useSession()

  // Handle login events - redirect to dashboard if session becomes available
  if (!isPending && session?.session !== undefined) {
    console.log('redirecting to dashboard')
    return <Navigate to="/" replace reloadDocument />
  }

  return <Outlet />
}
